var map = {
  "./km.json": [
    "177991",
    "873515"
  ],
  "./ru.json": [
    "244353",
    "793974"
  ],
  "./bg.json": [
    "928657",
    "473422"
  ],
  "./el.json": [
    "143214",
    "672401"
  ],
  "./en-pt.json": [
    "928588",
    "486516"
  ],
  "./ja.json": [
    "865427",
    "363417"
  ],
  "./ar.json": [
    "89441",
    "817170"
  ],
  "./rw.json": [
    "69866",
    "410760"
  ],
  "./sr.json": [
    "852755",
    "209459"
  ],
  "./lol.json": [
    "418076",
    "328005"
  ],
  "./fr.json": [
    "659391",
    "605602"
  ],
  "./sv.json": [
    "578450",
    "295730"
  ],
  "./as.json": [
    "463078",
    "747414"
  ],
  "./gu.json": [
    "331617",
    "355972"
  ],
  "./kk.json": [
    "914604",
    "729641"
  ],
  "./nb.json": [
    "622634",
    "40113"
  ],
  "./ta.json": [
    "414628",
    "321101"
  ],
  "./ky.json": [
    "111780",
    "668372"
  ],
  "./pl.json": [
    "155450",
    "511150"
  ],
  "./ro.json": [
    "539213",
    "605635"
  ],
  "./ka.json": [
    "789029",
    "815217"
  ],
  "./uk.json": [
    "308588",
    "219440"
  ],
  "./uz.json": [
    "304059",
    "456725"
  ],
  "./zh-hans.json": [
    "600704",
    "265489"
  ],
  "./hy.json": [
    "383448",
    "139228"
  ],
  "./de.json": [
    "568354",
    "119206"
  ],
  "./es-cl.json": [
    "56106",
    "366716"
  ],
  "./vi.json": [
    "283405",
    "483419"
  ],
  "./tr.json": [
    "306002",
    "148832"
  ],
  "./da.json": [
    "143272",
    "946037"
  ],
  "./kn.json": [
    "624631",
    "216785"
  ],
  "./id.json": [
    "858276",
    "873180"
  ],
  "./lt.json": [
    "59477",
    "198907"
  ],
  "./lv.json": [
    "825250",
    "398316"
  ],
  "./fv.json": [
    "416797",
    "759696"
  ],
  "./es.json": [
    "707864",
    "193527"
  ],
  "./bn.json": [
    "531664",
    "568705"
  ],
  "./cs.json": [
    "665885",
    "278347"
  ],
  "./boxes.json": [
    "231508",
    "138832"
  ],
  "./my.json": [
    "791102",
    "248302"
  ],
  "./mn.json": [
    "33276",
    "507806"
  ],
  "./sk.json": [
    "301689",
    "631692"
  ],
  "./nl.json": [
    "907930",
    "98508"
  ],
  "./accents.json": [
    "241270",
    "341183"
  ],
  "./pa.json": [
    "228906",
    "709442"
  ],
  "./pt.json": [
    "715139",
    "296811"
  ],
  "./extra.json": [
    "233087",
    "482227"
  ],
  "./it.json": [
    "586230",
    "470307"
  ],
  "./hi.json": [
    "952519",
    "895439"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 979268;
module.exports = webpackAsyncContext;
